import { Charts } from './Charts';
import ProfileChartsDataProvider from './contexts/ProfileChartsDataContext';

const ProfileWrapper = () => {
    return (
        <ProfileChartsDataProvider>
            <Charts />
        </ProfileChartsDataProvider>
    );
};

export default ProfileWrapper;
